module.exports = __webpack_public_path__ + "assets/img/wsf.52a68473.svg";